import { render, staticRenderFns } from "./RankingsDetailTableHeader.vue?vue&type=template&id=51bfae01&scoped=true"
import script from "./RankingsDetailTableHeader.vue?vue&type=script&lang=js"
export * from "./RankingsDetailTableHeader.vue?vue&type=script&lang=js"
import style0 from "./RankingsDetailTableHeader.vue?vue&type=style&index=0&id=51bfae01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bfae01",
  null
  
)

export default component.exports